<template>
  <div :class="'chapter-head chapter-head-' + level">
    <span :class="'chapter-head-title-' + level">
      {{title}}
    </span>
<!--    <span>-->
      <slot></slot>
<!--    </span>-->
    <span v-if="showWarning" :class="'chapter-head-extra-' + level">
      <i class="el-icon-warning" style="color: #F56C6C;"></i>
      <span style="font-size: 12px; color: rgb(192, 196, 204);">
        <slot name="warning"></slot>
      </span>
    </span>
    <span style="float: right;">
      <slot name="extra"></slot>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    level: {
      type: Number,
      default: 1
    },
    showWarning: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped type="scss">
.chapter-head {
  width: 100%;
  height: 25px;
  color: #333;
  /* position: relative;
  display: flex;
  align-items: center; */
}
.chapter-head-1 {
  padding: 12px 0px 12px;
  border-bottom: #bfbfbf 1px solid;
  margin-bottom: 16px;
  line-height: 30px;
  font-size: 16px;
}
.chapter-head-2 {
  padding: 12px 0px 0px;
  margin-bottom: 8px;
}
.chapter-head-title-1 {
  font-size: 16px;
  float: left;
}
.chapter-head-title-2 {
  font-size: 14px;
}
.chapter-head-title-2::before {
  content: "";
  display: inline-block;
  width: 4px;
  height: 16px;
  background: #E8556F;
  vertical-align: -2px;
  margin-right: 8px;
}
.chapter-head-extra-1 {
  font-size: 16px;
}
.chapter-head-extra-2 {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/business/ChapterHead.vue